<template>
  <div
    v-if="properties"
    :class="['grid-editor string', properties.classes]"
    :style="properties.styles">
    <el-form :model="form"
             ref="form"
             @submit.native.prevent="$emit('submit')">
      <el-form-item
        prop="model"
        :rules="properties.required">
        <el-input
          v-model="form.model"
          :placeholder="properties.placeholder"
          :size="properties.size"
          type="number"
          ref="field"
          @keyup.native.prevent.esc="$emit('cancel')"
          autofocus
          clearable/>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'EditorNumber',
  props: {
    options: { type: Object },
    data: { type: Object, required: true },
    isEdit: { type: Boolean, default: false }
  },
  watch: {
    options: 'parserOptions',
    data: 'parserDate',
    isEdit: 'handleIsVisible'
  },
  data () {
    return {
      form: { model: '' },
      properties: null
    }
  },
  created () {
    this.parserOptions()
    this.parserDate()
  },
  methods: {
    OPTIONS () {
      return {
        // main
        field: '',
        value: '',
        required: null,
        // style
        placeholder: this.L10n('please-input-number'),
        classes: '',
        styles: '',
        size: '',
        customBehaviour: false
      }
    },
    // General Parser
    parserOptions () {
      this.properties = this.$_.merge(this.OPTIONS(), this.options)
      // set default validate rule if (required === true)
      if ([true, 'true'].includes(this.properties.required)) {
        this.properties.required = this.getValidationRule('required')
      }
      this.setFocus()
    },
    parserDate () {
      this.form.model = this.data[this.properties.field]
      this.setFocus()
    },
    setFocus () {
      this.$nextTick(() => {
        if (this.$refs.field && this.$refs.field.$refs.input) this.$refs.field.$refs.input.focus()
      })
    },
    // PUBLIC
    validate () {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (valid) resolve(this.getValue())
        })
      })
    },
    getValue () {
      let result = {}
      result[this.properties.field] = Number(this.form.model)
      return result
    }
  }
}
</script>
